"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAxiosIntance = createAxiosIntance;
exports.rosolveBusinessException = rosolveBusinessException;
exports.applyInterceptors = applyInterceptors;
exports.post = post;
exports.get = get;
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

require("element-ui/lib/theme-chalk/src/base.css");

require("element-ui/lib/theme-chalk/src/message-box.css");

var _messageBox2 = _interopRequireDefault(require("element-ui/lib/message-box"));

require("core-js/modules/es.array-buffer.constructor.js");

require("core-js/modules/es.array-buffer.slice.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.typed-array.uint8-array.js");

require("core-js/modules/es.typed-array.copy-within.js");

require("core-js/modules/es.typed-array.every.js");

require("core-js/modules/es.typed-array.fill.js");

require("core-js/modules/es.typed-array.filter.js");

require("core-js/modules/es.typed-array.find.js");

require("core-js/modules/es.typed-array.find-index.js");

require("core-js/modules/es.typed-array.for-each.js");

require("core-js/modules/es.typed-array.includes.js");

require("core-js/modules/es.typed-array.index-of.js");

require("core-js/modules/es.typed-array.iterator.js");

require("core-js/modules/es.typed-array.join.js");

require("core-js/modules/es.typed-array.last-index-of.js");

require("core-js/modules/es.typed-array.map.js");

require("core-js/modules/es.typed-array.reduce.js");

require("core-js/modules/es.typed-array.reduce-right.js");

require("core-js/modules/es.typed-array.reverse.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.slice.js");

require("core-js/modules/es.typed-array.some.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.subarray.js");

require("core-js/modules/es.typed-array.to-locale-string.js");

require("core-js/modules/es.typed-array.to-string.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.index-of.js");

var _axios = _interopRequireDefault(require("axios"));

var _lodash = _interopRequireDefault(require("lodash"));

var _lang = _interopRequireDefault(require("@/lang"));

var _store = _interopRequireDefault(require("@/store"));

var TIMEOUT = process.env.TIMEOUT || 60000;
var ERROR_TYPE = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  //
  NO_LOGIN: 'NO_LOGIN',
  MAINTENANCE_MODE: 'MAINTENANCE_MODE',
  NO_AUTHORITY: 'NO_AUTHORITY'
};

function createAxiosIntance(baseURL) {
  var service = _axios["default"].create({
    baseURL: baseURL || process.env.BASE_API,
    // api的base_url
    timeout: TIMEOUT // 请求超时时间

  });

  applyInterceptors(service);
  return service;
} // 创建axios实例


var service = createAxiosIntance();

function rosolveBusinessException(response) {
  var notificationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var config = response.config;
  var shouldNotice = true;

  if (config) {
    shouldNotice = config.notification !== false;
  }

  var res = response.data;

  if (res instanceof ArrayBuffer && res.byteLength <= 2000) {
    try {
      res = JSON.parse(decodeURIComponent(escape(String.fromCharCode.apply(null, new Uint8Array(res)))));
    } catch (error) {
      console.log(error);
    }
  }

  var status = res.code || res.status;
  var msg = res.msg || res.message;
  var errorMsgNeedScrollbar = false;

  if (res.content && _lodash["default"].isArray(res.content.errorArr)) {
    if (res.content.errorArr.length > 2) {
      errorMsgNeedScrollbar = true;
    }

    msg = res.content.errorArr;
  } // 异步消息id记录


  var isTask = res.content && res.content.taskId && res.content.taskName && res.content.taskStatus;

  if (isTask) {
    _store["default"].dispatch('AddTaskId', res.content.taskId);
  }

  if (!res) {
    throw new Error('response data is correct');
  }

  if (status === ERROR_TYPE.NO_LOGIN || status === ERROR_TYPE.NO_AUTHORITY) {
    _store["default"].dispatch('FedLogOut').then(function () {
      location.href = "".concat(location.protocol, "//").concat(location.host, "/");
    });

    return response;
  } else if (status === ERROR_TYPE.MAINTENANCE_MODE) {
    _store["default"].dispatch('EnterMaintenanceMode');
  } else if (status === ERROR_TYPE.ERROR) {
    if (config) {
      shouldNotice = shouldNotice && config.hasErrorNotification !== false;
    }

    shouldNotice && _store["default"].dispatch('OpenNotification', {
      message: msg,
      i18n: false,
      option: {
        scrollbar: errorMsgNeedScrollbar
      }
    });
    return Promise.reject(res);
  } else {
    if (config) {
      shouldNotice = shouldNotice && config.hasSuccessNotification !== false;
    } // const shouldNotice = config.notification !== false && config.hasSuccessNotification !== false;
    // shouldNotice && msg && store.dispatch('OpenNotification', { message: msg, type: 'success', i18n: false });.


    if (shouldNotice && msg) {
      var opt = {
        message: msg,
        type: 'success',
        i18n: false
      };

      if (notificationId) {
        opt.id = notificationId;
      }

      _store["default"].dispatch('OpenNotification', opt);
    }

    return response;
  }
}

function applyInterceptors(service) {
  // request拦截器
  service.interceptors.request.use(function (config) {
    // Do something before request is sent
    // if (store.getters.token) {
    //   config.headers['X-Token'] = getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    // }
    if (!config.notConverData && config.data !== void 0) {
      config.data = JSON.stringify(config.data);
    }

    if (config.headers && !config.headers['Content-Type']) {
      config.headers = config.headers || {};
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  }, function (error) {
    // Do something with request error
    _store["default"].dispatch('OpenNotification', {
      message: 'serviceError.0'
    });

    Promise.reject(error);
  }); // respone拦截器

  service.interceptors.response.use(rosolveBusinessException, function (error) {
    console.log('err' + error); // for debug

    var config = error.config;
    var shouldNotice = true;

    if (config) {
      shouldNotice = config.notification !== false && config.hasErrorNotification !== false;
    }

    if (error && error.response && error.response.status !== 401) {
      error.msg = _lang["default"].t('serviceError.' + error.response.status);
      shouldNotice && _store["default"].dispatch('OpenNotification', {
        message: error.msg,
        i18n: false
      });
    } else if (error && error.response && error.response.status === 401) {
      _messageBox2["default"].confirm(_lang["default"].t('serviceError.authError'), _lang["default"].t('decideGoOut'), {
        confirmButtonText: _lang["default"].t('loginAgain'),
        cancelButtonText: _lang["default"].t('cancel'),
        type: 'warning'
      }).then(function () {
        _store["default"].dispatch('FedLogOut').then(function () {
          location.reload();
        });
      }, function () {});
    } else if (error && error.stack && error.stack.indexOf('timeout') !== -1) {
      shouldNotice && _store["default"].dispatch('OpenNotification', {
        message: 'serviceError.timeout'
      });
    }

    return Promise.reject(error);
  });
}

function post(url, data) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TIMEOUT;
  var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // const autoRefresh = !!store.getters.refreshTimerId;
  return service((0, _objectSpread2["default"])({
    url: process.env.AJAX_BASE_API + url,
    method: 'post',
    data: data || {},
    timeout: timeout,
    withCredentials: true
  }, opt));
}

function get(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TIMEOUT;

  if (!_lodash["default"].isObject(data)) {
    throw new Error('data is not object, url is ' + url);
  }

  return service({
    url: process.env.AJAX_BASE_API + url,
    method: 'get',
    params: data,
    timeout: timeout
  });
}

var _default = service;
exports["default"] = _default;